export const getChecklistData = (checklists) => {
  var NotStarted = 0;
  var Pending = 0;
  var complete = 0;

  checklists.forEach((checklist) => {
    const completed = checklist.hasOwnProperty("rows")
      ? checklist.rows.filter(
          (row) =>
            (row.hasOwnProperty("value") &&
              row.value.length > 0 &&
              row["Row Type"] !== "Header" &&
              row["Row Type"] !== "Information Row") ||
            (row.hasOwnProperty("value") &&
              row.value.hasOwnProperty("url") &&
              row.value.url.length > 0 &&
              row["Row Type"] !== "Header" &&
              row["Row Type"] !== "Information Row"),
        ).length
      : 0;
    const incompleted = checklist.hasOwnProperty("rows")
      ? checklist.rows.filter(
          (row) => row.hasOwnProperty("value") && row.value.length === 0,
        ).length
      : 0;
    const rowCount = checklist.hasOwnProperty("rows")
      ? checklist.rows.filter(
          (row) =>
            row["Row Type"] !== "Header" &&
            row["Row Type"] !== "Information Row",
        ).length
      : 0;
    if (completed === rowCount) {
      complete += 1;
    } else if (incompleted === rowCount) {
      NotStarted += 1;
    } else {
      Pending += 1;
    }
  });

  return [
    {
      order: 1,
      name: `Not Started (${NotStarted})`,
      value: NotStarted,
      color: "#7e57c2",
    },
    {
      order: 2,
      name: `Pending (${Pending})`,
      value: Pending,
      color: "#fdd835",
    },
    {
      order: 3,
      name: `Complete (${complete})`,
      value: complete,
      color: "#50C878",
    },
  ];
};
